// extracted by mini-css-extract-plugin
export default {"selector":"ComponentSelector_selector__hvOJO","select":"ComponentSelector_select__jHcIn"};